function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Br\xEDet",
  transform: "translate(-1566.000000, -3038.000000)",
  fill: "#88949D"
}, React.createElement("g", {
  id: "instagram.2",
  transform: "translate(1566.000000, 3038.000000)"
}, React.createElement("path", {
  d: "M20.5,24.002 L3.5,24.002 C1.57,24.002 0,22.432 0,20.502 L0,3.502 C0,1.572 1.57,0.002 3.5,0.002 L20.5,0.002 C22.43,0.002 24,1.572 24,3.502 L24,20.502 C24,22.432 22.43,24.002 20.5,24.002 Z M3.5,1.002 C2.121,1.002 1,2.124 1,3.502 L1,20.502 C1,21.88 2.121,23.002 3.5,23.002 L20.5,23.002 C21.879,23.002 23,21.88 23,20.502 L23,3.502 C23,2.124 21.879,1.002 20.5,1.002 L3.5,1.002 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M8.5,8.002 L0.5,8.002 C0.224,8.002 0,7.778 0,7.502 C0,7.226 0.224,7.002 0.5,7.002 L8.5,7.002 C8.776,7.002 9,7.226 9,7.502 C9,7.778 8.776,8.002 8.5,8.002 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M23.5,8.002 L15.5,8.002 C15.224,8.002 15,7.778 15,7.502 C15,7.226 15.224,7.002 15.5,7.002 L23.5,7.002 C23.776,7.002 24,7.226 24,7.502 C24,7.778 23.776,8.002 23.5,8.002 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M20.5,6.002 L17.5,6.002 C17.224,6.002 17,5.778 17,5.502 L17,2.502 C17,2.226 17.224,2.002 17.5,2.002 L20.5,2.002 C20.776,2.002 21,2.226 21,2.502 L21,5.502 C21,5.778 20.776,6.002 20.5,6.002 Z M18,5.002 L20,5.002 L20,3.002 L18,3.002 L18,5.002 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M2.5,5.002 C2.224,5.002 2,4.778 2,4.502 L2,1.002 C2,0.726 2.224,0.502 2.5,0.502 C2.776,0.502 3,0.726 3,1.002 L3,4.502 C3,4.778 2.776,5.002 2.5,5.002 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M4.5,5.002 C4.224,5.002 4,4.778 4,4.502 L4,0.502 C4,0.226 4.224,0.002 4.5,0.002 C4.776,0.002 5,0.226 5,0.502 L5,4.502 C5,4.778 4.776,5.002 4.5,5.002 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M6.5,5.002 C6.224,5.002 6,4.778 6,4.502 L6,0.502 C6,0.226 6.224,0.002 6.5,0.002 C6.776,0.002 7,0.226 7,0.502 L7,4.502 C7,4.778 6.776,5.002 6.5,5.002 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M12,18.002 C8.691,18.002 6,15.311 6,12.002 C6,8.693 8.691,6.002 12,6.002 C15.309,6.002 18,8.693 18,12.002 C18,15.311 15.309,18.002 12,18.002 Z M12,7.002 C9.243,7.002 7,9.245 7,12.002 C7,14.759 9.243,17.002 12,17.002 C14.757,17.002 17,14.759 17,12.002 C17,9.245 14.757,7.002 12,7.002 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M12,15.002 C10.346,15.002 9,13.656 9,12.002 C9,10.348 10.346,9.002 12,9.002 C13.654,9.002 15,10.348 15,12.002 C15,13.656 13.654,15.002 12,15.002 Z M12,10.002 C10.897,10.002 10,10.899 10,12.002 C10,13.105 10.897,14.002 12,14.002 C13.103,14.002 14,13.105 14,12.002 C14,10.899 13.103,10.002 12,10.002 Z",
  id: "Shape",
  fillRule: "nonzero"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/instagram.df05d17d.svg";
export { SvgComponent as ReactComponent };